'use client';

import createSvg from './createSvg';

export default createSvg(({ height, width, ...props }) => (
  <svg height={height || 24} width={width || 24} {...props} viewBox="0 0 24 24">
    <path fill="currentColor" d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z" />
  </svg>
));
